import Layout from "../components/layout/Layout";
import VolatilityMessageDetail from "../components/VolatilityMessageDetail";

const VolatilityMessageDetailPage = () => {

  return (
    <Layout>
        <VolatilityMessageDetail />
    </Layout>
  );
};
export default VolatilityMessageDetailPage;
